import React, { useState, useEffect } from 'react'
import NavbarUser from '../../components/navbar/NavbarUser'
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../components/datatable/AppDataGrid';
import { columns } from './component/journalhistory/columnJournalhistory';
import FetchApi from '../customhooks/Functionapi';
import { useDemoData } from '@mui/x-data-grid-generator';


import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import PageHeader from '../../components/pageheader/PageHeader';
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import { HiClipboardDocumentList } from "react-icons/hi2";
import PopUpViewProcess from './component/viewflowprocess/PopUpViewProcess';
import PopUpViewFlowstatus from './component/viewflowprocess/PopUpViewFlowstatus';
import { GridActions, ActionButton, ActionPopup } from '../../components/datatable/GridActions';

// เพิ่มปุ่ม Revise เฉพาะหน้านี้ (columns ใช้ร่วมกับหน้าอื่น จึงไม่แก้ไฟล์ต้นทาง)
// Revise ได้เฉพาะเอกสารที่ Successful เหมือนเงื่อนไขในหน้า /documents
const versionColumn = {
  field: 'Revise',
  headerName: 'Version',
  width: 90,
  valueGetter: (value) => (value === null || value === undefined || value === '') ? '' : `V.${value}`,
};

const historyColumns = columns.flatMap((col) => col.field === 'JournalCode' ? [col, versionColumn] : [col]).map((col) => col.field !== 'actions' ? col : {
  ...col,
  renderCell: (params) => (
    <GridActions>
      <ActionPopup tone="view"><PopUpViewProcess jourId={params.row.JournalID} /></ActionPopup>
      <ActionPopup tone="flow"><PopUpViewFlowstatus jourId={params.row.JournalID} /></ActionPopup>
      {params.row.statusName === 'Successful' &&
        <ActionButton to={`/revisedocuments/${params.row.JournalID}`} title="Revise" tone="revise">
          <HiClipboardDocumentList />
        </ActionButton>}
    </GridActions>
  )
});

const JournalHistory = () => {

  const { data, loading } = useDemoData({
    dataSet: 'Commodity',
    rowLength: 10,
    maxColumns: 6,
  });

  const FetchApis = new FetchApi();
  const [datalist, setDatalist] = useState([])
  const [dataAll, setDataAll] = useState([])

  useEffect(() => {
    getJournalHistorylist()
  }, [])

  const getJournalHistorylist = async () => {
    await FetchApis.FethcGet(`/document/DocumentListall`).then(res => {

      if (res.status == 200) {

        setDatalist(res.data);
        setDataAll(res.data);
      }

    })
  }
  
  function getRowId(row) {
    return row.JournalID;
  }

  const filterBySearch = (event) => {

    const query = event.target.value;

    const filteredData = dataAll.filter(item => {
      return Object.values(item)
        .join('')
        .toLowerCase()
        .includes(query.toLowerCase());
    });

    setDatalist(filteredData);
  };

  return (
    <div>
      <NavbarUser />
      <main className="container mx-auto px-4 py-8" style={{ padding: 10, backgroundColor: '#f7f7f7' }}>
        <PageHeader
          title="Search History List All"
          subtitle="Manage document search journal list"
          icon={ManageSearchRoundedIcon}
          color="#00897b"
          count={datalist.length}
          onSearch={(e) => filterBySearch(e)}
        />
        <div>
          <div style={{ marginTop: 20 }}>
            <AppDataGrid
              rows={datalist}
              getRowId={getRowId}
              columns={historyColumns}
              loading={loading}
              slots={{ toolbar: GridToolbar }}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[10, 25, 50, 100]}
            />
          </div>
        </div>
      </main>
    </div>
  )
}

export default JournalHistory